export default __webpack_public_path__ + "images/investing-resources.svg";